import { KEY_ESCAPE } from "keycode-js";
import { useCallback } from "react";

import { useHotKey, type HotKeyDefinition } from "~/client/components/HotKey";

enum Command {
  CLOSE,
}

const HotKeyDefinitions: ReadonlyArray<HotKeyDefinition<Command>> = [
  {
    keyCode: KEY_ESCAPE,
    command: Command.CLOSE,
  },
];

export const useCloseByKey = (onClose: () => void) => {
  const onDispatch = useCallback(
    (command: Command) => {
      switch (command) {
        case Command.CLOSE:
          onClose();
          return;
      }
    },
    [onClose],
  );
  useHotKey({ definitions: HotKeyDefinitions, onDispatch });
};
